var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotEffect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 119,
    viewBox: "0 0 164 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2501 13.5642C13.2501 14.8764 12.8616 16.159 12.1336 17.25C11.4057 18.341 10.371 19.1914 9.16042 19.6935C7.94987 20.1956 6.61781 20.327 5.33269 20.071C4.04757 19.8151 2.86711 19.1832 1.94059 18.2554C1.01408 17.3276 0.383109 16.1454 0.127483 14.8585C-0.128143 13.5716 0.00305361 12.2376 0.504482 11.0254C1.00591 9.81313 1.85505 8.777 2.94452 8.04801C4.03399 7.31903 5.31486 6.92993 6.62516 6.92993C8.38221 6.92993 10.0673 7.6289 11.3097 8.87307C12.5521 10.1172 13.2501 11.8047 13.2501 13.5642Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2501 46.4945C13.2512 47.8069 12.8635 49.0901 12.1362 50.1818C11.4088 51.2735 10.3745 52.1246 9.16405 52.6276C7.95359 53.1305 6.62136 53.2626 5.3359 53.0072C4.05044 52.7518 2.86949 52.1204 1.94245 51.1928C1.0154 50.2652 0.383917 49.0831 0.127867 47.796C-0.128184 46.5089 0.00270637 45.1747 0.50398 43.9622C1.00525 42.7496 1.85439 41.7131 2.94397 40.9839C4.03356 40.2547 5.31464 39.8655 6.62515 39.8655C8.3813 39.8655 10.0656 40.5637 11.3079 41.8068C12.5501 43.0498 13.2487 44.7359 13.2501 46.4945Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2501 79.4142C13.2512 80.7266 12.8635 82.0098 12.1362 83.1014C11.4088 84.1931 10.3745 85.0443 9.16405 85.5472C7.95359 86.0502 6.62136 86.1823 5.3359 85.9269C4.05044 85.6715 2.86949 85.0401 1.94245 84.1125C1.0154 83.1848 0.383917 82.0027 0.127867 80.7157C-0.128184 79.4286 0.00270637 78.0944 0.50398 76.8818C1.00525 75.6693 1.85439 74.6328 2.94397 73.9036C4.03356 73.1744 5.31464 72.7852 6.62515 72.7852C8.3813 72.7852 10.0656 73.4834 11.3079 74.7264C12.5501 75.9695 13.2487 77.6556 13.2501 79.4142Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2501 112.36C13.2512 113.673 12.8635 114.956 12.1362 116.047C11.4088 117.139 10.3745 117.99 9.16405 118.493C7.95359 118.996 6.62136 119.128 5.3359 118.873C4.05044 118.618 2.86949 117.986 1.94245 117.059C1.0154 116.131 0.383917 114.949 0.127867 113.662C-0.128184 112.375 0.00270637 111.04 0.50398 109.828C1.00525 108.615 1.85439 107.579 2.94397 106.85C4.03356 106.12 5.31464 105.731 6.62515 105.731C8.3813 105.731 10.0656 106.429 11.3079 107.672C12.5501 108.916 13.2487 110.602 13.2501 112.36Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7783 16.1665C44.2133 12.7992 42.6506 8.90451 39.288 7.46752C35.9254 6.03054 32.0362 7.5954 30.6013 10.9627C29.1663 14.3301 30.729 18.2247 34.0916 19.6617C37.4542 21.0987 41.3434 19.5338 42.7783 16.1665Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.306 46.4946C43.3071 47.8063 42.9198 49.0888 42.1931 50.1802C41.4665 51.2715 40.4331 52.1227 39.2236 52.6261C38.014 53.1295 36.6826 53.2625 35.3976 53.0084C34.1125 52.7543 32.9316 52.1244 32.0039 51.1984C31.0762 50.2723 30.4435 49.0917 30.1857 47.8056C29.9279 46.5196 30.0565 45.1859 30.5554 43.9731C31.0543 42.7602 31.9009 41.7227 32.9885 40.9916C34.076 40.2605 35.3555 39.8686 36.6654 39.8655C37.5364 39.8628 38.3995 40.0322 39.205 40.3641C40.0106 40.696 40.7428 41.1838 41.3598 41.7997C41.9767 42.4155 42.4662 43.1472 42.8001 43.9529C43.1341 44.7585 43.306 45.6223 43.306 46.4946Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6863 86.0538C40.3422 86.0538 43.306 83.0858 43.306 79.4247C43.306 75.7636 40.3422 72.7957 36.6863 72.7957C33.0303 72.7957 30.0665 75.7636 30.0665 79.4247C30.0665 83.0858 33.0303 86.0538 36.6863 86.0538Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.306 112.36C43.3071 113.672 42.9198 114.955 42.1931 116.046C41.4665 117.137 40.4331 117.988 39.2236 118.492C38.014 118.995 36.6826 119.128 35.3976 118.874C34.1125 118.62 32.9316 117.99 32.0039 117.064C31.0762 116.138 30.4435 114.957 30.1857 113.671C29.9279 112.385 30.0565 111.052 30.5554 109.839C31.0543 108.626 31.9009 107.588 32.9885 106.857C34.076 106.126 35.3555 105.734 36.6654 105.731C37.5364 105.728 38.3995 105.898 39.205 106.23C40.0106 106.562 40.7428 107.05 41.3598 107.665C41.9767 108.281 42.4662 109.013 42.8001 109.819C43.1341 110.624 43.306 111.488 43.306 112.36Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3672 13.5642C73.3672 14.8764 72.9786 16.159 72.2507 17.25C71.5227 18.341 70.488 19.1914 69.2775 19.6935C68.0669 20.1956 66.7349 20.327 65.4498 20.071C64.1646 19.8151 62.9842 19.1832 62.0577 18.2554C61.1311 17.3276 60.5002 16.1454 60.2445 14.8585C59.9889 13.5716 60.1201 12.2376 60.6215 11.0254C61.123 9.81313 61.9721 8.777 63.0616 8.04802C64.1511 7.31903 65.4319 6.92993 66.7422 6.92993C67.6124 6.92924 68.4742 7.10037 69.2783 7.43353C70.0824 7.76669 70.813 8.25535 71.4283 8.87153C72.0436 9.48772 72.5316 10.2194 72.8643 11.0246C73.197 11.8298 73.3679 12.6928 73.3672 13.5642Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3672 46.4945C73.3682 47.8069 72.9806 49.0901 72.2532 50.1818C71.5259 51.2735 70.4916 52.1246 69.2811 52.6276C68.0707 53.1305 66.7384 53.2626 65.453 53.0072C64.1675 52.7518 62.9866 52.1204 62.0595 51.1928C61.1325 50.2652 60.501 49.0831 60.2449 47.796C59.9889 46.5089 60.1198 45.1747 60.621 43.9622C61.1223 42.7496 61.9715 41.7131 63.061 40.9839C64.1506 40.2547 65.4317 39.8655 66.7422 39.8655C67.612 39.8648 68.4733 40.0358 69.2771 40.3686C70.0808 40.7014 70.8112 41.1896 71.4265 41.8052C72.0417 42.4209 72.5298 43.1519 72.8628 43.9565C73.1958 44.7611 73.3672 45.6235 73.3672 46.4945Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3672 79.4142C73.3682 80.7266 72.9806 82.0098 72.2532 83.1014C71.5259 84.1931 70.4916 85.0443 69.2811 85.5472C68.0707 86.0502 66.7384 86.1823 65.453 85.9269C64.1675 85.6715 62.9866 85.0401 62.0595 84.1125C61.1325 83.1848 60.501 82.0027 60.2449 80.7157C59.9889 79.4286 60.1198 78.0944 60.621 76.8818C61.1223 75.6693 61.9715 74.6328 63.061 73.9036C64.1506 73.1744 65.4317 72.7852 66.7422 72.7852C68.4984 72.7852 70.1827 73.4834 71.4249 74.7264C72.6672 75.9695 73.3658 77.6556 73.3672 79.4142Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3672 112.36C73.3682 113.673 72.9806 114.956 72.2532 116.047C71.5259 117.139 70.4916 117.99 69.2811 118.493C68.0707 118.996 66.7384 119.128 65.453 118.873C64.1675 118.618 62.9866 117.986 62.0595 117.059C61.1325 116.131 60.501 114.949 60.2449 113.662C59.9889 112.375 60.1198 111.04 60.621 109.828C61.1223 108.615 61.9715 107.579 63.061 106.85C64.1506 106.12 65.4317 105.731 66.7422 105.731C67.612 105.731 68.4733 105.901 69.2771 106.234C70.0808 106.567 70.8112 107.055 71.4265 107.671C72.0417 108.287 72.5298 109.018 72.8628 109.822C73.1958 110.627 73.3672 111.489 73.3672 112.36Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.898 16.1672C104.333 12.7999 102.77 8.90524 99.4075 7.46826C96.0449 6.03128 92.1558 7.59613 90.7208 10.9635C89.2858 14.3308 90.8485 18.2255 94.2111 19.6624C97.5737 21.0994 101.463 19.5346 102.898 16.1672Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.423 46.4945C103.423 47.8056 103.035 49.0873 102.307 50.1774C101.58 51.2676 100.546 52.1172 99.3365 52.619C98.1269 53.1207 96.7959 53.252 95.5118 52.9962C94.2277 52.7404 93.0482 52.1091 92.1224 51.182C91.1966 50.2549 90.5662 49.0737 90.3107 47.7878C90.0553 46.5019 90.1864 45.169 90.6874 43.9577C91.1885 42.7464 92.0369 41.7111 93.1255 40.9827C94.2141 40.2543 95.494 39.8655 96.8033 39.8655C98.5589 39.8655 100.243 40.5639 101.484 41.8071C102.726 43.0503 103.423 44.7364 103.423 46.4945Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8033 86.0538C100.459 86.0538 103.423 83.0858 103.423 79.4247C103.423 75.7636 100.459 72.7957 96.8033 72.7957C93.1473 72.7957 90.1835 75.7636 90.1835 79.4247C90.1835 83.0858 93.1473 86.0538 96.8033 86.0538Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.423 112.36C103.423 113.671 103.035 114.953 102.307 116.043C101.58 117.133 100.546 117.983 99.3365 118.485C98.1269 118.986 96.7959 119.118 95.5118 118.862C94.2277 118.606 93.0482 117.975 92.1224 117.048C91.1966 116.121 90.5662 114.939 90.3107 113.654C90.0553 112.368 90.1864 111.035 90.6874 109.823C91.1885 108.612 92.0369 107.577 93.1255 106.848C94.2141 106.12 95.494 105.731 96.8033 105.731C98.5589 105.731 100.243 106.43 101.484 107.673C102.726 108.916 103.423 110.602 103.423 112.36Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M132.957 16.1702C134.392 12.8028 132.829 8.90817 129.466 7.47119C126.104 6.0342 122.215 7.59906 120.78 10.9664C119.345 14.3337 120.907 18.2284 124.27 19.6654C127.632 21.1023 131.522 19.5375 132.957 16.1702Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M133.484 46.4945C133.485 47.8069 133.098 49.0901 132.37 50.1818C131.643 51.2735 130.609 52.1246 129.398 52.6276C128.188 53.1305 126.855 53.2626 125.57 53.0072C124.285 52.7518 123.104 52.1204 122.177 51.1928C121.249 50.2652 120.618 49.0831 120.362 47.796C120.106 46.5089 120.237 45.1747 120.738 43.9622C121.239 42.7496 122.088 41.7131 123.178 40.9839C124.268 40.2547 125.549 39.8655 126.859 39.8655C127.729 39.8648 128.59 40.0358 129.394 40.3686C130.198 40.7014 130.928 41.1896 131.543 41.8052C132.159 42.4209 132.647 43.1519 132.98 43.9565C133.313 44.7611 133.484 45.6235 133.484 46.4945Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M126.859 86.0538C130.515 86.0538 133.479 83.0858 133.479 79.4247C133.479 75.7636 130.515 72.7957 126.859 72.7957C123.203 72.7957 120.24 75.7636 120.24 79.4247C120.24 83.0858 123.203 86.0538 126.859 86.0538Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M133.484 112.36C133.485 113.673 133.098 114.956 132.37 116.047C131.643 117.139 130.609 117.99 129.398 118.493C128.188 118.996 126.855 119.128 125.57 118.873C124.285 118.618 123.104 117.986 122.177 117.059C121.249 116.131 120.618 114.949 120.362 113.662C120.106 112.375 120.237 111.04 120.738 109.828C121.239 108.615 122.088 107.579 123.178 106.85C124.268 106.12 125.549 105.731 126.859 105.731C127.729 105.731 128.59 105.901 129.394 106.234C130.198 106.567 130.928 107.055 131.543 107.671C132.159 108.287 132.647 109.018 132.98 109.822C133.313 110.627 133.484 111.489 133.484 112.36Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M163.54 13.5642C163.539 14.8751 163.15 16.1562 162.422 17.2457C161.694 18.3351 160.66 19.184 159.45 19.6849C158.24 20.1859 156.909 20.3164 155.626 20.06C154.342 19.8036 153.163 19.1719 152.238 18.2446C151.312 17.3173 150.682 16.1361 150.427 14.8503C150.172 13.5645 150.304 12.2319 150.805 11.0209C151.306 9.80995 152.155 8.77494 153.243 8.04676C154.332 7.31859 155.611 6.92993 156.92 6.92993C157.79 6.92993 158.651 7.10157 159.455 7.43504C160.258 7.76851 160.988 8.25727 161.603 8.87339C162.218 9.48951 162.705 10.2209 163.038 11.0258C163.37 11.8307 163.541 12.6932 163.54 13.5642Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M163.54 46.4945C163.54 47.8056 163.152 49.0873 162.424 50.1774C161.697 51.2676 160.663 52.1172 159.454 52.619C158.244 53.1207 156.913 53.252 155.629 52.9962C154.345 52.7404 153.165 52.1091 152.239 51.182C151.314 50.2549 150.683 49.0737 150.428 47.7878C150.172 46.5019 150.303 45.169 150.805 43.9577C151.306 42.7464 152.154 41.7111 153.243 40.9827C154.331 40.2543 155.611 39.8655 156.92 39.8655C158.676 39.8655 160.36 40.5639 161.601 41.8071C162.843 43.0503 163.54 44.7364 163.54 46.4945Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M163.54 79.4142C163.54 80.7253 163.152 82.007 162.424 83.0971C161.697 84.1873 160.663 85.0369 159.454 85.5386C158.244 86.0404 156.913 86.1717 155.629 85.9159C154.345 85.6601 153.165 85.0287 152.239 84.1017C151.314 83.1746 150.683 81.9934 150.428 80.7075C150.172 79.4216 150.303 78.0887 150.805 76.8774C151.306 75.6661 152.154 74.6308 153.243 73.9023C154.331 73.1739 155.611 72.7852 156.92 72.7852C158.676 72.7852 160.36 73.4836 161.601 74.7268C162.843 75.9699 163.54 77.6561 163.54 79.4142Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M163.54 112.36C163.54 113.671 163.152 114.953 162.424 116.043C161.697 117.133 160.663 117.983 159.454 118.485C158.244 118.986 156.913 119.118 155.629 118.862C154.345 118.606 153.165 117.975 152.239 117.048C151.314 116.121 150.683 114.939 150.428 113.654C150.172 112.368 150.303 111.035 150.805 109.823C151.306 108.612 152.154 107.577 153.243 106.848C154.331 106.12 155.611 105.731 156.92 105.731C158.676 105.731 160.36 106.43 161.601 107.673C162.843 108.916 163.54 110.602 163.54 112.36Z",
    fill: "#E6E6E6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotEffect);
export default __webpack_public_path__ + "static/media/dot_effect.1bf57fb9df2ddede596a8d35356cd2b7.svg";
export { ForwardRef as ReactComponent };